import axios from 'axios';
import { VENTAS } from './types';
import { changeLoader } from './loader';
import { setAlert } from './alert';

const toUrlEncoded = (data = {}) => {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value === undefined) {
            return;
        }
        if (value === null) {
            params.append(key, '');
            return;
        }
        if (typeof value === 'object') {
            params.append(key, JSON.stringify(value));
            return;
        }
        params.append(key, String(value));
    });
    return params.toString();
};

export const limpiarVentaCreada = () => async (dispatch) => {
    dispatch({ type: VENTAS.LIMPIAR_VENTA });
};

export const listarMetodosVenta = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_metodos`);
        await dispatch({
            type: VENTAS.METODOS_LISTAR,
            payload: res.data?.metodos || []
        });
        await dispatch(changeLoader(false));
        return res.data?.metodos || [];
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar métodos de pago', 'danger'));
        return [];
    }
};

export const buscarClientesVenta = (busqueda) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ busqueda: busqueda || '' });

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/listar_clientes`,
            body,
            config
        );

        const clientes = res.data?.clientes || [];

        await dispatch({
            type: VENTAS.CLIENTES_BUSCAR,
            payload: Array.isArray(clientes) ? clientes : []
        });

        return Array.isArray(clientes) ? clientes : [];
    } catch (error) {
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al buscar clientes', 'danger'));
        return [];
    }
};

export const crearClienteVenta = ({ nombre, correo, telefono, rfc }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        nombre: nombre || '',
        correo: correo || '',
        telefono: telefono || '',
        rfc: rfc || ''
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/crear_cliente`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear el cliente', 'danger'));
            return null;
        }

        const cliente = res.data?.cliente || null;

        await dispatch({
            type: VENTAS.CLIENTE_CREADO,
            payload: cliente
        });

        dispatch(setAlert(res.data?.msg || 'Cliente creado correctamente', 'success'));
        return cliente;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear cliente', 'danger'));
        return null;
    }
};

export const listarProductosVenta = ({ codigo, codigo_proveedor, nombre }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        codigo: codigo || null,
        codigo_proveedor: codigo_proveedor || null,
        nombre: nombre || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/listar_productos`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        const productos = res.data?.productos || [];

        await dispatch({
            type: VENTAS.PRODUCTOS_LISTAR,
            payload: Array.isArray(productos) ? productos : []
        });

        return Array.isArray(productos) ? productos : [];
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar productos', 'danger'));
        return [];
    }
};

export const limpiarProductosVenta = () => async (dispatch) => {
    dispatch({ type: VENTAS.PRODUCTOS_LIMPIAR });
};

export const cargarCategoriasVenta = () => async (dispatch) => {
    try {
        let res = null;

        try {
            res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_categorias`);
        } catch (e) {
            res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar`);
        }

        await dispatch({
            type: VENTAS.CATEGORIAS_CARGADAS,
            payload: res.data?.categorias || []
        });

        return res.data?.categorias || [];
    } catch (error) {
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar categorías', 'danger'));
        return [];
    }
};

export const cargarSubcategoriasVenta = (idCategoria) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ id: idCategoria || '' });

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_subcategorias`,
            body,
            config
        );

        await dispatch({
            type: VENTAS.SUBCATEGORIAS_CARGADAS,
            payload: res.data?.subcategorias || []
        });

        return res.data?.subcategorias || [];
    } catch (error) {
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar subcategorías', 'danger'));
        return [];
    }
};

export const limpiarSubcategoriasVenta = () => async (dispatch) => {
    dispatch({ type: VENTAS.SUBCATEGORIAS_CARGADAS, payload: [] });
};

export const buscarProductosInventarioVenta = ({
    id_categoria = null,
    id_subcategoria = null,
    nombre = null,
    codigo_tienda = null,
    codigo_proveedor = null
} = {}) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        id_proveedor: null,
        id_categoria: id_categoria || null,
        id_subcategoria: id_subcategoria || null,
        nombre: nombre || null,
        codigo_tienda: codigo_tienda || null,
        codigo_proveedor: codigo_proveedor || null,
        status: null
    });

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/inventario/listar`,
            body,
            config
        );

        const productos = res.data?.productos || [];

        await dispatch({
            type: VENTAS.INVENTARIO_PRODUCTOS_LISTAR,
            payload: Array.isArray(productos) ? productos : []
        });

        return Array.isArray(productos) ? productos : [];
    } catch (error) {
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al buscar productos', 'danger'));
        return [];
    }
};

export const limpiarProductosInventarioVenta = () => async (dispatch) => {
    dispatch({ type: VENTAS.INVENTARIO_PRODUCTOS_LIMPIAR });
};

export const cargarDetalleProductoVenta = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ id: id || '' });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/inventario/detalles`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        const producto = res.data?.producto || null;

        await dispatch({
            type: VENTAS.DETALLE_PRODUCTO,
            payload: producto
        });

        return producto;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar el producto', 'danger'));
        return null;
    }
};

export const limpiarDetalleProductoVenta = () => async (dispatch) => {
    dispatch({ type: VENTAS.LIMPIAR_DETALLE_PRODUCTO });
};

export const crearVenta = ({ id_cliente, id_metodo, tipo, cobro_inmediato, moneda, tipo_cambio, total, productos, paquetes }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = {
        id_cliente: id_cliente || null,
        id_metodo: id_metodo !== undefined && id_metodo !== null ? id_metodo : null,
        tipo: tipo !== undefined && tipo !== null ? Number(tipo) : 0,
        cobro_inmediato: cobro_inmediato === undefined || cobro_inmediato === null ? true : cobro_inmediato,
        moneda: moneda !== undefined && moneda !== null ? Number(moneda) : 0,
        tipo_cambio: tipo_cambio ? Number(tipo_cambio) : 1,
        total: total === undefined || total === null ? 0 : total,
        productos: Array.isArray(productos) ? productos : [],
        paquetes: Array.isArray(paquetes) ? paquetes : []
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/crear_venta`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo registrar la venta', 'danger'));
            return null;
        }

        await dispatch({
            type: VENTAS.VENTA_CREADA,
            payload: res.data?.venta || null
        });

        dispatch(setAlert(res.data?.msg || 'Venta creada correctamente', 'success'));
        return res.data?.venta || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al registrar venta', 'danger'));
        return null;
    }
};

export const listarVentas = ({ folio = null, metodo = null, fecha_inicio = null, fecha_fin = null, tipo = 0 } = {}) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        folio: folio || null,
        metodo: metodo || null,
        fecha_inicio: fecha_inicio || null,
        fecha_fin: fecha_fin || null,
        tipo: tipo !== undefined && tipo !== null ? Number(tipo) : 0,
        status: true
    });

    try {
        await dispatch({ type: VENTAS.LISTAR_VENTAS_CARGANDO });
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/listar_ventas`,
            body,
            config
        );

        await dispatch({
            type: VENTAS.LISTAR_VENTAS,
            payload: res.data?.ventas || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar ventas', 'danger'));
        return false;
    }
};

export const cancelarVenta = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ id });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/cancelar_venta`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo cancelar la venta', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Venta cancelada correctamente', 'success'));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cancelar venta', 'danger'));
        return false;
    }
};

export const cargarDetallesVenta = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ id });

    try {
        await dispatch({ type: VENTAS.DETALLES_VENTA_CARGANDO });
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/detalles_venta`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            await dispatch({ type: VENTAS.ERROR });
            dispatch(setAlert(res.data?.msg || 'No se pudo consultar el detalle de la venta', 'danger'));
            return false;
        }

        await dispatch({
            type: VENTAS.DETALLES_VENTA,
            payload: res.data?.venta || null
        });

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar detalle de venta', 'danger'));
        return false;
    }
};

export const limpiarDetallesVenta = () => async (dispatch) => {
    dispatch({ type: VENTAS.LIMPIAR_DETALLES_VENTA });
};

export const cargarVentaEdicion = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const params = new URLSearchParams();
    params.append('id', id);

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/detalles_venta`,
            params.toString(),
            config
        );

        if (!res.data?.success) {
            await dispatch(changeLoader(false));
            await dispatch({ type: VENTAS.ERROR });
            dispatch(setAlert(res.data?.msg || 'No se pudo cargar la venta', 'danger'));
            return false;
        }

        await dispatch({
            type: VENTAS.DETALLES_EDITAR,
            payload: res.data?.venta || null
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar detalles de la venta', 'danger'));
        return false;
    }
};

export const limpiarVentaEdicion = () => async (dispatch) => {
    await dispatch({ type: VENTAS.LIMPIAR_DETALLES_EDITAR });
};

export const listarDevolucionesVenta = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const params = new URLSearchParams();
    params.append('id', id);

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/devoluciones_venta`,
            params.toString(),
            config
        );

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo consultar el historial de devoluciones', 'danger'));
            return [];
        }

        await dispatch({
            type: VENTAS.DEVOLUCIONES_LISTAR,
            payload: res.data?.devoluciones || []
        });

        return res.data?.devoluciones || [];
    } catch (error) {
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar el historial de devoluciones', 'danger'));
        return [];
    }
};

export const editarVenta = ({ id, id_cliente, id_metodo, tipo, cobro_inmediato, moneda, tipo_cambio, fecha, total, productos, paquetes }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = {
        id: id || null,
        id_cliente: id_cliente || null,
        id_metodo: id_metodo !== undefined && id_metodo !== null ? id_metodo : null,
        tipo: tipo !== undefined && tipo !== null ? Number(tipo) : 0,
        cobro_inmediato: cobro_inmediato === undefined || cobro_inmediato === null ? true : cobro_inmediato,
        moneda: moneda !== undefined && moneda !== null ? Number(moneda) : 0,
        tipo_cambio: tipo_cambio ? Number(tipo_cambio) : 1,
        fecha: fecha || null,
        total: total === undefined || total === null ? 0 : total,
        productos: Array.isArray(productos) ? productos : [],
        paquetes: Array.isArray(paquetes) ? paquetes : []
    };

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/ventas/editar_venta`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar la venta', 'danger'));
            return null;
        }

        await dispatch({
            type: VENTAS.EDITAR_OK,
            payload: res.data?.venta || null
        });

        dispatch(setAlert(res.data?.msg || 'Venta editada correctamente', 'success'));
        return res.data?.venta || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar la venta', 'danger'));
        return null;
    }
};

/* Lee el mensaje de error de una respuesta con responseType 'blob': cuando el backend responde
   400/500, el cuerpo (JSON con { msg, success }) llega como Blob y no como objeto ya parseado. */
const extraerMensajeErrorBlob = async (error) => {
    try {
        const blob = error?.response?.data;
        if (blob instanceof Blob) {
            const texto = await blob.text();
            const json = JSON.parse(texto);
            return json?.msg || null;
        }
    } catch (err) {
        // El cuerpo no era JSON (ej. sí es un PDF de error genérico del servidor); se ignora.
    }
    return null;
};

/* Pide el PDF de la venta al backend (endpoint aún por implementarse ahí) y lo abre
   en una pestaña nueva usando el visor de PDF nativo del navegador. */
export const generarPdfVenta = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ventas/pdf`, body, config);
        await dispatch(changeLoader(false));

        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        const msg = await extraerMensajeErrorBlob(error);
        dispatch(setAlert(msg || 'Error al generar el PDF de la venta', 'danger'));
        return false;
    }
};
